<template>
  <div>
    <breadcrumbs :back="[{text:'Spirits',to:{name:'InventorySpirits'}}]" :home="spirit.details.name+': transactions'"/>

    <v-container fluid class="pb-0 pt-2">
      <v-row dense>
        <v-col cols="12" sm="4" md="3" lg="2">
          <date-range :from.sync="filters.from" :to.sync="filters.to"  @change="refresh()" ref="dateRange" hide-details class="pt-2"/>
        </v-col>
        <v-col align="right">
          <print-list :table="this.$refs.table" title="Spirits" pageSize="portrait"/>
          <export-list :columns="defaultColumns" :headers="headers" :list="filteredList" fileName="transactions.csv" :table="this.$refs.table"/>
        </v-col>
      </v-row>
    </v-container>

    <v-data-table ref="table" class="purtrak-table"
       v-bind="listProps" :page.sync="page" :items-per-page.sync="pageSize"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
        @click:row="item => selectedId = item.id">
      <template v-slot:item.volume="{value}">
        {{value | number(1)}} LAA
      </template>
    </v-data-table>

  </div>
</template>

<script>
import commonList from '@/mixins/commonList'

export default {
  name: 'InventorySpiritsTransactions',
  mixins: [commonList],
  props: {
    spiritId: {type:String, required:true},
  },
  data() {
    return {
      objectType: 'spirit transactions',
      _name: 'spirittransactions',
      filters: {
        from: null,
        to: null,
      },
      spirit: {transactions:[],details:{}},
      columns: [],
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'description', visible:true},
                       { value: 'volume', visible:true}],
      headers: [{ text: 'DATE/TIME', value: 'date', width:'20%',sortable:true},
                { text: 'DESCRIPTION', value: 'description', width:'60%',sortable:true},
                { text: 'VOLUME', value: 'volume', width:'20%',align:'right'}],
    }
  },
  computed: {
    activeHeaders() {
      return this.headers;
    },
    filteredList() {
      return this.spirit.transactions;
    }
  },
  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query InventorySpiritsTransactions($customerId:ID!,$spiritId:ID!,$from:Date!,$to:Date!) {
                                              portalCustomer(customerId:$customerId) {
                                                spirit(id:$spiritId) {
                                                  details {
                                                    name
                                                  }
                                                  transactions(from:$from,to:$to) {
                                                    id,date,description,volume
                                                  }
                                                }
                                              }
                                            }`,
                                            {customerId:this.$store.state.customerId,spiritId:this.spiritId,
                                             from:this.filters.from,to:this.filters.to});
      if (!results.error)
        this.spirit = results.data.portalCustomer.spirit;
      this.loading = false;
    }
  }
}
</script>